import type { MaterialLineItemOption } from "../types";
import type { MaterialRowItem } from "./materialLineItems";

export function buildCategoryEditKeys(
    materialsByGroup: Record<string, MaterialRowItem[]>,
) {
    const editKeyByCategory: Record<string, string> = {};
    const optionsByEditKey: Record<string, MaterialLineItemOption[]> = {};

    for (const rows of Object.values(materialsByGroup)) {
        for (const row of rows) {
            if (row.mode !== "single") continue;
            editKeyByCategory[row.category] = row.id;
            optionsByEditKey[row.id] = row.availableProducts;
        }
    }

    return { editKeyByCategory, optionsByEditKey };
}

export function resolveProductIdInOptions(
    manufacturerProductId: string,
    options: MaterialLineItemOption[],
): string | null {
    for (const option of options) {
        if (option.ProductId === manufacturerProductId) {
            return manufacturerProductId;
        }
        const exactVariant = option.Variants?.find(
            (variant) => variant.ProductId === manufacturerProductId,
        );
        if (exactVariant) return exactVariant.ProductId;
    }

    const prefix = `${manufacturerProductId}-`;
    for (const option of options) {
        if (option.ProductId.startsWith(prefix)) {
            return option.ProductId;
        }
        const prefixed = option.Variants?.find((variant) =>
            variant.ProductId.startsWith(prefix),
        );
        if (prefixed) return prefixed.ProductId;
    }

    return null;
}
